import React from 'react';
import { Box, Typography, ListItemText, ListItem, List, Skeleton } from '@barracuda-internal/bds-core';

// Material-UI based Vulnerabilities list with Drawer details and pagination
export default function Vulnerabilities({title, subtitle }) {
  return (
    <Box sx={{ p: 2 }}>
      <Typography variant="h5" gutterBottom>{title}</Typography>
      {subtitle && (
        <Typography variant="promoCaptionSubtle" gutterBottom>{subtitle}</Typography>
      )}
        <>

          <List disablePadding>
            {[0,1,2,3,4,5,6,7,8,9].map((v, idx) => (
              <React.Fragment key={`${v}-${idx}`}>
                <ListItem
                  sx={{
                    display: 'grid',
                    gridTemplateColumns: '1fr 260px auto',
                    alignItems: 'center',
                    px: 1,
                    columnGap: 4,
                  }}
                >
                  {/* Column 1: Title */}
                  <ListItemText
                    disableTypography
                    primary={
                      <Typography sx={{ fontWeight: 600, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                        <Skeleton variant="text" sx={{ fontSize: '1rem' }} width={600} />
                      </Typography>
                    }
                    sx={{ overflow: 'hidden' }}
                  />
                  
                  {/* Column 2: Severity (center column) */}
                  <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', px: 1, textAlign: 'center' }}>
                      <Skeleton variant="text" sx={{ fontSize: '1rem' }} width={200} />
                  </Box>

                  {/* Column 3: Actions */}
                  <Box sx={{ justifySelf: 'end' }}>
                    <Skeleton variant="text" sx={{ fontSize: '1rem' }} width={200} />
                  </Box>
                </ListItem>

              </React.Fragment>
            ))}
          </List>
        </>
    </Box>
  );
}
